import { render } from "./ToggleSidebar.vue?vue&type=template&id=bc9e3462"
import script from "./ToggleSidebar.vue?vue&type=script&lang=js"
export * from "./ToggleSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script